import { useNavigate } from 'react-router-dom';

import {
  TableHeader,
  Typography,
  TableContainer,
  SearchForm,
  SearchFormProps,
} from '@occc-app/design-system';
import { useGetLoyaltyEventsList } from '@occc-app/dataAccessLayer/loyaltyEvent/queries';
import { usePaginationParams } from '@occc-app/hooks/usePaginationParams';
import { useSearchParams } from '@occc-app/hooks/useSearchParams';
import { useChainId } from '@occc-app/Chain/hooks';
import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';
import { Earning_Mechanism_Typename } from '@occc/graphql';

import { LoyaltyEventTable } from './LoyaltyEventTable';

export const LoyaltyEventTableContainer = () => {
  const navigate = useNavigate();
  const chainId = useChainId();

  const isUserPermittedToEditLoyaltyEvent = useIsUserPermittedTo(Feature.LOYALTY_EVENT_EDIT);
  const isUserPermittedToDeleteLoyaltyEvent = useIsUserPermittedTo(Feature.LOYALTY_EVENT_DELETE);

  const [search, setSearch] = useSearchParams();
  const [paginationInfo, onPageChange] = usePaginationParams();

  const { loading, error, data, paginationProps } = useGetLoyaltyEventsList({
    filter: {
      chainIdEquals: chainId,
      search,
      earningMechanismTypenameIncludes: [Earning_Mechanism_Typename.EarningMechanismLoyaltyEvent],
    },
    paginationInfo,
    onPageChange,
  });

  const onRowClick = (id: string) => navigate(id);

  const onSearch: SearchFormProps['onSubmit'] = ({ search }) => {
    setSearch(search);
  };

  return (
    <TableContainer>
      <TableHeader
        title={
          <Typography variant='h6' component='h3'>
            Loyalty Event Offers
          </Typography>
        }
        disableTitleTypography
        actions={<SearchForm onSubmit={onSearch} initialValues={{ search }} />}
      />
      <LoyaltyEventTable
        offers={data}
        loading={loading}
        error={error}
        paginationProps={paginationProps}
        onRowClick={onRowClick}
        isEditActionVisible={isUserPermittedToEditLoyaltyEvent}
        isArchiveActionVisible={isUserPermittedToDeleteLoyaltyEvent}
      />
    </TableContainer>
  );
};
